export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-xl font-extrabold font-display text-gray-900">Configurações</h1>
      <p className="text-sm text-gray-500">Configurações da conta e da plataforma podem ser gerenciadas aqui.</p>

      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm space-y-4">
        <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider">Informações da Conta</h2>
        <p className="text-sm text-gray-500">As configurações de perfil e permissões serão implementadas em breve.</p>
      </div>
    </div>
  )
}
